class HeaderCustomLanguageView {
    enButton = document.querySelector('.mb-lang-switcher__en')
    arButton = document.querySelector('.mb-lang-switcher__ar')
    enButtonMob = document.querySelector('.mb-lang-switcher__en_mob')
    arButtonMob = document.querySelector('.mb-lang-switcher__ar_mob')    

    hanldeLanguageSwitcher() {
        window.addEventListener('DOMContentLoaded', () => {
            this.enButton?.addEventListener('click', () => {
                const url = new URL(location.href);
                const pathNameArray = url.pathname.split('/');
                pathNameArray.splice(0, 2);

                const newPathName = "/" + pathNameArray.join('/')
                url.pathname = newPathName
                location.replace(url.href)
            })
            this.arButton?.addEventListener('click', () => {
                const url = new URL(location.href);
                const pathNameArray = url.pathname.split('/');
                const newPathName = "/ar" + pathNameArray.join('/')
                url.pathname = newPathName
                location.replace(url.href)
            })
            this.enButtonMob?.addEventListener('click', () => {
                const url = new URL(location.href);
                const pathNameArray = url.pathname.split('/');
                pathNameArray.splice(0, 2);

                const newPathName = "/" + pathNameArray.join('/')
                url.pathname = newPathName
                location.replace(url.href)
            })
            this.arButtonMob?.addEventListener('click', () => {
                const url = new URL(location.href);
                const pathNameArray = url.pathname.split('/');
                const newPathName = "/ar" + pathNameArray.join('/')
                url.pathname = newPathName
                location.replace(url.href)
            })
        })
    };
}

export default new HeaderCustomLanguageView();

 //  Return to Hompage script
 let return_hp = document.querySelector(".return_to_hp");
 return_hp.addEventListener('click',()=> {
    document.querySelector(".mb-burger-icon").click();
});